const SMALL_WORDS = new Set([
  'a', 'an', 'the', 'and', 'or', 'of', 'to', 'for', 'in', 'on', 'by', 'with', 'as',
]);

function capitalizeWord(word, { allowSmallWord }) {
  if (!word || !/[A-Za-z]/.test(word)) return word;
  const letters = word.replace(/[^A-Za-z]/g, '');
  if (allowSmallWord && SMALL_WORDS.has(letters.toLowerCase()) && letters.toLowerCase() === word.toLowerCase()) {
    return word.toLowerCase();
  }
  if (/^[A-Z0-9]{2,}$/.test(letters) && letters === word) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/**
 * Title-case a wizard data-entry label.
 * "escalation amount" -> "Escalation Amount"
 * "maximum purchase price" -> "Maximum Purchase Price"
 * Underscores in raw field keys become spaces.
 */
export function titleCaseFieldLabel(value) {
  const text = String(value || '').trim().replace(/_/g, ' ').replace(/\s+/g, ' ');
  if (!text) return '';
  let wordIndex = 0;
  return text.split(/(\s+)/).map((token) => {
    if (/^\s+$/.test(token)) return token;
    const isFirstWord = wordIndex === 0;
    wordIndex += 1;
    return token.split('-').map((segment, segmentIndex) => (
      capitalizeWord(segment, { allowSmallWord: !isFirstWord && segmentIndex === 0 })
    )).join('-');
  }).join('');
}
